/**
 * Global Style Variables
 */

const variable = {
  breakpoint: {
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,

    // alias
    desktop: 1200,
    pad: 992,
    tablet: 768,
    mobile: 576,
  },
};

export default variable;
